import { Inject, Injectable, Optional } from '@angular/core';

import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { EarlyPayoutAcceptance } from '@frontend/sports/user/feature';

import { IBetslipState } from '../../../../../../../base/store/state';
import { BetslipType } from '../../../../../../../core/betslip-type';
import { IBetslip } from '../../../../../../bet-generation/models';
import { BetslipError } from '../../../../../errors/betslip-error';
import { EDIT_BET_BETSLIP_VALIDATORS } from '../../../../betslip-validation-injection-tokens';
import { TypeContextGeneratorService } from '../../../../generators/context/type-context-generator.service';
import { IEditBetBetslipValidator } from '../../../../validators/betslip/validators';
import { IBetslipValidationComposer } from '../../betslip-validation-composers';

@Injectable()
export class EditBetBetslipValidationComposerService implements IBetslipValidationComposer {
    constructor(
        @Optional()
        @Inject(EDIT_BET_BETSLIP_VALIDATORS)
        private editBetBetslipValidators: IEditBetBetslipValidator<BetslipError>[],
        private typeContextGenerator: TypeContextGeneratorService,
    ) {}

    validateBetslip(betslip: IBetslip, state: IBetslipState, acceptance: Nullable<EarlyPayoutAcceptance>): BetslipError[] {
        if (!this.editBetBetslipValidators?.length || state.types.base.currentSelectedType !== BetslipType.EditBet) {
            return [];
        }

        const editBetContext = this.typeContextGenerator.generateEditBetContext(state.types.editBet);

        return this.editBetBetslipValidators.flatMap((v) => Array.from(v.validate(betslip, editBetContext, acceptance)));
    }
}
